import * as React from 'react'
import {
    useHistory,
    useParams
} from 'react-router-dom'

import { getStartedGame } from '../../services/game-services'
import { useInvokeEffect } from '../../utils/helper'

export const Linker: React.FC = () => {
    const { gameId } = useParams() as any
    const history = useHistory()

    useInvokeEffect(async () => {
        if (gameId) {
            const game = await getStartedGame(gameId)
            history.push({ pathname: '/spil', state: { game } })
        } else {
            history.push('/')
        }
    })

    return (
        <div />
    )
}
